/*
 * RMC is a single page application and the js code below is intended to support this functionality
 */

/**
 * User types constants
 * @type p: number
 */
const USER_TYPES = {
  distributor: 3,
  axcient: 2,
  reseller: 1,
  client: 0,
}

/**
 * Real URL base constants
 * @type p: string
 */
const EXACT_URL_BASES = {
  distributor: 'distributor',
  reseller: 'reseller',
  client: 'client',
  appliance: 'appliance',
  dashboard: 'dashboard',
  dashboardUMC: 'dashboardumc',
  device: 'device',
  job: 'job',
  devices: 'devices',
  vault: 'vault',
  user: 'user',
  licenses: 'licenses',
  reports: 'reports',
  admin: 'admin',
  upgrader: 'upgrader',
  settings: 'settings',
  azure_export: 'azure_export',
};

/**
 * Real URL composite base constants
 * These constants are required to process tricky places in our URL mappings
 * @type p: string
 */
const EXACT_URL_COMPOSITE_BASES = {
  clientDetails: 'client/details',
};

/**
 * Real URL extension constants
 * @type p: string
 */
const EXACT_URL_EXTENSIONS = {
  emptyTable: 'empty_table',
  dashboard: 'dashboard',
  details: 'details',
  index: 'index',
  clientApplianceList: 'client_appliance_list',
};

/**
 * Real URL composite extension constants
 * These constants are required to process tricky places in our URL mappings
 * @type p: string
 */
const EXACT_URL_COMPOSITE_EXTENSIONS = {
  adminIndex: 'admin/admin_index',
  upgraderIndex: 'upgrader/upgrader_index',
};

/**
 * Friendly URL base constants
 * @type p: string
 */
const FRIENDLY_URL_BASES = {
  distributor: 'distributor',
  reseller: 'reseller',
  client: 'client',
  appliance: 'appliance',
  device: 'device',
  devices: 'devices',
  vault: 'vault',
  licenses: 'licenses',
  user: 'user',
  reports: 'reports',
  job: 'job',
  client_settings: 'client_settings',
  reseller_settings: 'reseller_settings',
  vault_settings: 'vault_settings',
  appliance_settings: 'appliance_settings',
  virtualOffice_settings: 'virtualoffice_settings',
  appliance_list: 'appliance_list',
  inventory: 'inventory',
};

/**
 * Friendly URL extension constants
 * @type p: string
 */
const FRIENDLY_URL_EXTENSIONS = {
  virtualOffice: 'virtualoffice'
};

/**
 * Tab selectors constants
 * @type p: string
 */
const TAB_SELECTORS = {
  distributor: 'distributors-tab',
  resellers: 'resellers-tab',
  appliances: 'appliances-tab',
  clients: 'clients-tab',
  devices: 'devices-tab',
  vault: 'vault-tab',
  users: 'users-tab',
  licenses: 'licenses-tab',
  reports: 'reports-tab',
  admin: 'admin-tab',
  support: 'support-tab',
  resellerDashboard: 'reseller-dashboard-tab',
  supportAppliances: 'support-appliances-tab',
}

/**
 * This function allows to switch content on the page, i.e. it provides transitions between "pages" (which are actually tabs).
 * @param url - (optional) url for content which should be loaded by ajax from the server and shown on the tab
 * @param targetTabSelector - (optional) selector for the tab to open this content in (e.g. li.<class name>)
 * @param targetElementId - (optional) DOM element id; if found, the tab with this content is shown but not reloaded
  */
const tabsGoTo = (url, targetTabSelector, targetElementId) => {
  if (url && url.charAt(0) !== '/') {
    url = '/' + url;
  }
  const $tabs = $('#tabs'),
      tabsWidget = $tabs.tabs('instance');
  let selIndex = $tabs.tabs('option', 'active');

  if (url === '/') {
    if (selIndex === 0) {
      const activeA = tabsWidget.active.find('a'),
          tabUrl = $tabs.data('originalURLs')[0];
      if (tabUrl && tabUrl !== activeA.attr('href')) {
        activeA.attr('href', tabUrl);
        tabsWidget.active.removeData(JQUERY_UI_TAB_CACHE_KEY);
      }
      $tabs.tabs('load', 0);
    } else {
      $tabs.tabs('option', 'active', 0);
    }
    return;
  }

  if (!url || url === '#') {
    // reload current tab
    tabsWidget.active.removeData(JQUERY_UI_TAB_CACHE_KEY);
    $tabs.tabs("load", selIndex);
    return;
  }

  if (!!targetElementId) {
    const $targetElement = $('#' + targetElementId + ':visible');
    if ($targetElement.length > 0) {
      selIndex = $targetElement.closest('.ui-tabs-panel').index('.ui-tabs-panel');
      $tabs.tabs('option', 'active', selIndex);
      return;
    }
  }

  //track the loaded page
  gtag('event', 'Page', {
    'event_category': 'View',
    'event_label': url
  })

  let destIndex = selIndex;

  if (!!targetTabSelector) {
    destIndex = $tabs.find(targetTabSelector).index();
  }

  const $anchor = $(tabsWidget.anchors[destIndex]);
  $anchor.attr('href', url);
  if (!window.isForthOrBackAction || selIndex === destIndex) {
    $anchor.parent().removeData(JQUERY_UI_TAB_CACHE_KEY);
  }

  if (selIndex !== destIndex) {
    $tabs.tabs('option', 'active', destIndex);
  } else {
    $tabs.tabs('load', destIndex);
  }
}

/**
 * This function gets tab by index, resets its cache and reloads it
 * @index - index of a tab which is needed to reload
 */
const tabReloadByIndex = (index) => {
  const $tabs = $('#tabs'),
      tabsWidget = $tabs.tabs('instance');

  $(tabsWidget.tabs[index]).removeData(JQUERY_UI_TAB_CACHE_KEY);
  $tabs.tabs("load", index);
}

/**
 * This function forces active tab reloading
 */
const activeTabReload  = () => {
  const index = $('#tabs').tabs('option', 'active');
  tabReloadByIndex(index);
}

/**
 * This function gets tab containing specified $containedElement and reloads it
 * @$containedElement - jquery wrapped element
 */
const tabReloadByElement = ($containedElement) => {
  if ($containedElement !== undefined && $containedElement.length) {
    const index = $containedElement.closest('.ui-tabs-panel').index('.ui-tabs-panel');
    if (index >= 0) {
      tabReloadByIndex(index);
    }
  }
}

const initPopstateListener = () => {
  window.addEventListener('popstate', e => {
    if (e.state) {
      window.isForthOrBackAction = true;
      tabs_goto(e.state.exactUrl, e.state.targetTabSelector);
      window.isForthOrBackAction = undefined;
    }
  });
}

/**
 * Creates user-friendly URL from an original one depending on userType
 * @param {string} originalUrl Original URL string
 * @param {string|number} userType Logged in user type should be one of [0, 1, 2]
 * @returns {string|*}
 */
const createUserFriendlyUrl = (originalUrl, userType) => {
  const originalUrlWithQuery = originalUrl.split('?');
  const originalUrlWithoutQuery = originalUrlWithQuery[0];
  const originalUrlQuery = originalUrlWithQuery[1] ? originalUrlWithQuery[1] : '';

  const splitUrl = originalUrlWithoutQuery.split('/');
  if (!Object.values(USER_TYPES).includes(parseInt(userType))) {
    return splitUrl[1];
  }
  const resultUrl = [];

  const urlBase = getFriendlyUrlBase(originalUrl, splitUrl);
  resultUrl.push(urlBase);

  const urlIdString = getFriendlyUrlId(originalUrl, urlBase, userType);
  if (urlIdString) {
    resultUrl.push(urlIdString);
  }

  const urlExtension = getFriendlyUrlExtension(originalUrl, splitUrl, urlBase);
  if (urlExtension) {
    resultUrl.push(urlExtension);
  }

  return resultUrl.join('/') + (originalUrlQuery ? '?' + originalUrlQuery : '');
}

/**
 * Creates user-friendly base for friendly URL from an original URL
 * @param {string} originalUrl Original URL string
 * @param {string[]} splitUrl Array of original URL components
 * @returns {string}
 */
const getFriendlyUrlBase = (originalUrl, splitUrl) => {
  const deepenUrlBases = [EXACT_URL_BASES.settings, EXACT_URL_BASES.admin, EXACT_URL_BASES.dashboardUMC, EXACT_URL_BASES.dashboard];
  let urlBase;
  if (deepenUrlBases.includes(splitUrl[1]) && splitUrl.length >= 3) {
    urlBase = splitUrl[2];
  } else {
    urlBase = splitUrl[1];
  }
  return urlBase;
}

/**
 * Returns id for displaying in friendly URL if it's not restricted
 * @param {string} originalUrl Original URL string
 * @param {string} urlBase URL base selected for displaying
 * @param {string|number} userType Logged in user type should be one of [0, 1, 2]
 * @returns {string}
 */
const getFriendlyUrlId = (originalUrl, urlBase, userType) => {
  const restrictIdDisplayingBases = getRestrictIdDisplayingBases(userType);
  return restrictIdDisplayingBases.includes(urlBase) ? null : getUrlId(originalUrl);
}

/**
 * Creates user-friendly extension for friendly URL from an original URL
 * @param {string} originalUrl Original URL string
 * @param {string[]} splitUrl Array of original URL components
 * @param {string} urlBase URL base selected for displaying
 * @returns {string}
 */
const getFriendlyUrlExtension = (originalUrl, splitUrl, urlBase) => {
  const urlExtendingBases = [EXACT_URL_BASES.client, EXACT_URL_BASES.reseller];
  const restrictedExtensions = [EXACT_URL_EXTENSIONS.emptyTable, EXACT_URL_EXTENSIONS.dashboard, EXACT_URL_EXTENSIONS.details, EXACT_URL_EXTENSIONS.index];
  let urlExtensionString;
  if (urlExtendingBases.includes(urlBase)) {
    const isVoRe = /\/\d+\/1/;
    const isVoReResult = isVoRe.exec(originalUrl);
    if (isVoReResult) {
      urlExtensionString = FRIENDLY_URL_EXTENSIONS.virtualOffice;
    } else if (splitUrl.length >= 3 && !restrictedExtensions.includes(splitUrl[2])) {
      urlExtensionString = splitUrl[2];
    }
  }
  return urlExtensionString;
}

/**
 * Creates the real URL from the friendly one
 * @param {string} friendlyUrl A friendly URL passed to browser
 * @param {string|number} userType Logged in user type should be one of [0, 1, 2]
 * @param {string|number} userEntityId Logged in user entity (reseller or client) id
 * @returns {null|string}
 */
const getExactUrlFromFriendly = (friendlyUrl, userType, userEntityId) => {
  const splitFriendlyUrl = friendlyUrl.split('/');
  if (splitFriendlyUrl[1] !== 'home') {
    return null;
  }

  const friendlyUrlBase = splitFriendlyUrl[2];
  const friendlyUrlId = getUrlId(friendlyUrl);
  const friendlyUrlExtension = extractFriendlyUrlExtension(friendlyUrl, friendlyUrlBase, userType);

  return mapFriendlyUrlPartsToExactUrl(friendlyUrlBase, friendlyUrlId, friendlyUrlExtension, userType, userEntityId);
}

/**
 * Returns a passed friendly URL extension if exists
 * @param {string} friendlyUrl A friendly URL passed to browser
 * @param {string} friendlyUrlBase Extracted friendly URL base
 * @param {string|number} userType Logged in user type should be one of [0, 1, 2]
 * @returns {string}
 */
const extractFriendlyUrlExtension = (friendlyUrl, friendlyUrlBase, userType) => {
  const restrictIdDisplayingBases = getRestrictIdDisplayingBases(userType);
  const idLessExtensionRe = /home\/[^/]+\/([^/\d]+)/;
  const extensionRe = /home\/[^/]+\/\d+\/([^/]+)/;

  const regex = restrictIdDisplayingBases.includes(friendlyUrlBase) ? idLessExtensionRe : extensionRe;
  const extensionReResult = regex.exec(friendlyUrl);
  return extensionReResult && extensionReResult[1];
}

/**
 * Returns numeric part of any passed URL
 * @param {string} urlString Any URL
 * @returns {string}
 */
const getUrlId = (urlString) => {
  const idRe = /\/(\d+)/;
  const urlIdReResult = idRe.exec(urlString);
  return urlIdReResult && urlIdReResult[1];
}

/**
 * Maps extracted friendly URL components to the real URL
 * @param {string} friendlyUrlBase Extracted friendly URL base
 * @param {string} friendlyUrlId Extracted friendly URL id
 * @param {string} friendlyUrlExtension Extracted friendly URL extension
 * @param {string|number} userType Logged in user type should be one of [0, 1, 2]
 * @param {string|number} userEntityId Logged in user entity (reseller or client) id
 * @returns {string|null}
 */
const mapFriendlyUrlPartsToExactUrl = (friendlyUrlBase, friendlyUrlId, friendlyUrlExtension, userType, userEntityId) => {
  const friendlyUrlBaseWithQuery = friendlyUrlBase.split('?');
  const friendlyUrlBaseWithoutQuery = friendlyUrlBaseWithQuery[0];
  const friendlyUrlQuery = friendlyUrlBaseWithQuery[1] ? friendlyUrlBaseWithQuery[1] : '';

  let resultUrl = [];

  if (userEntityId && isNaN(userEntityId)) {
    return null;
  }

  const urlBase = mapFriendlyUrlBaseToExact(friendlyUrlBaseWithoutQuery, friendlyUrlExtension);
  resultUrl.push(urlBase);

  const urlId = mapFriendlyIdToExact(friendlyUrlBaseWithoutQuery, friendlyUrlExtension, friendlyUrlId, userType, userEntityId);

  const urlExtension = mapFriendlyExtensionToExact(friendlyUrlBaseWithoutQuery, urlId, friendlyUrlExtension);
  if (urlExtension) {
    resultUrl.push(urlExtension);
  }
  if (urlId) {
    resultUrl.push(urlId);
  }

  return resultUrl.join('/') + (friendlyUrlQuery ? '?' + friendlyUrlQuery : '');
}

/**
 * Maps the friendly URL base to the real one, can be dependent on friendly extension
 * @param {string} friendlyUrlBase Extracted friendly URL base
 * @param {string} friendlyUrlExtension Extracted friendly URL extension
 * @returns {string}
 */
const mapFriendlyUrlBaseToExact = (friendlyUrlBase, friendlyUrlExtension) => {
  const friendlyBasesMap = {
    'client_settings': EXACT_URL_BASES.settings,
    'reseller_settings': EXACT_URL_BASES.settings,
    'vault_settings': EXACT_URL_BASES.settings,
    'virtualoffice_settings': EXACT_URL_BASES.settings,
    'appliance_settings': EXACT_URL_BASES.settings,
    'appliance_list': EXACT_URL_BASES.dashboard,
    'inventory': EXACT_URL_BASES.dashboardUMC,
  };
  const friendlyExtensionsBasesMap = {
    'appliance_list': EXACT_URL_BASES.appliance,
    'virtualoffice': EXACT_URL_COMPOSITE_BASES.clientDetails,
  };
  let exactBase;

  if (friendlyBasesMap[friendlyUrlBase]) {
    exactBase = friendlyBasesMap[friendlyUrlBase];
  } else if (friendlyExtensionsBasesMap[friendlyUrlExtension]) {
    exactBase = friendlyExtensionsBasesMap[friendlyUrlExtension];
  }

  return exactBase || friendlyUrlBase;
}

/**
 * Maps the friendly URL extension to the real one, can be dependent on URL id and friendly URL base
 * @param {string} friendlyUrlBase Extracted friendly URL base
 * @param {string} urlId Prepared URL id
 * @param {string} friendlyUrlExtension Extracted friendly URL extension
 * @returns {string|*}
 */
const mapFriendlyExtensionToExact = (friendlyUrlBase, urlId, friendlyUrlExtension) => {
  const friendlyBasesExtensionsMap = {
    'admin': EXACT_URL_COMPOSITE_EXTENSIONS.adminIndex,
    'upgrader': EXACT_URL_COMPOSITE_EXTENSIONS.upgraderIndex,
  }
  const friendlyExtensionsMap = {
    'appliance_list': EXACT_URL_EXTENSIONS.clientApplianceList,
  };
  const detailsBases = [FRIENDLY_URL_BASES.appliance, FRIENDLY_URL_BASES.device, FRIENDLY_URL_BASES.reseller, FRIENDLY_URL_BASES.vault, FRIENDLY_URL_BASES.client, FRIENDLY_URL_BASES.job];
  const dashboardBases = [];
  const emptyTableBases = [FRIENDLY_URL_BASES.appliance, FRIENDLY_URL_BASES.reseller, FRIENDLY_URL_BASES.client, FRIENDLY_URL_BASES.devices, FRIENDLY_URL_BASES.vault, FRIENDLY_URL_BASES.licenses, FRIENDLY_URL_BASES.user, FRIENDLY_URL_BASES.distributor];
  const indexTableBases = [FRIENDLY_URL_BASES.reports];
  const viewTableBases = [FRIENDLY_URL_BASES.client_settings, FRIENDLY_URL_BASES.vault_settings, FRIENDLY_URL_BASES.reseller_settings, FRIENDLY_URL_BASES.appliance_settings, FRIENDLY_URL_BASES.virtualOffice_settings];
  const viewOnDashboardTableBases = ['azure_export'];

  let exactExtension;

  if (friendlyBasesExtensionsMap[friendlyUrlBase]) {
    exactExtension = friendlyBasesExtensionsMap[friendlyUrlBase];
  } else if (friendlyExtensionsMap[friendlyUrlExtension]) {
    exactExtension = friendlyExtensionsMap[friendlyUrlExtension];
  } else if (!friendlyUrlExtension) {
    if (detailsBases.includes(friendlyUrlBase) && urlId) {
      exactExtension = EXACT_URL_EXTENSIONS.details
    } else if (dashboardBases.includes(friendlyUrlBase) && urlId) {
      exactExtension = EXACT_URL_EXTENSIONS.dashboard
    } else if (emptyTableBases.includes(friendlyUrlBase) && !urlId) {
      exactExtension = EXACT_URL_EXTENSIONS.emptyTable
    } else if (indexTableBases.includes(friendlyUrlBase)) {
      exactExtension = EXACT_URL_EXTENSIONS.index
    } else if (viewTableBases.includes(friendlyUrlBase)) {
      exactExtension = [friendlyUrlBase, 'view'].join('/');
    } else if (viewOnDashboardTableBases.includes(friendlyUrlBase)) {
      exactExtension = 'view';
    } else {
      exactExtension = friendlyUrlBase;
    }
  } else if (friendlyUrlExtension === FRIENDLY_URL_EXTENSIONS.virtualOffice) {
    return null
  }

  return exactExtension || friendlyUrlExtension;
}

/**
 * Returns id extracted from friendly URL or entity id depending on real URL base
 * @param {string} exactUrlBase Real URL base constructed from friendly URL
 * @param {string} friendlyUrlExtension Extracted friendly URL extension
 * @param {string} friendlyUrlId Id extracted from friendly URl
 * @param {string|number} userType Logged in user type should be one of [0, 1, 2]
 * @param {string|number} userEntityId Logged in user entity (reseller or client) id
 * @returns {string|number|undefined}
 */
const mapFriendlyIdToExact = (exactUrlBase, friendlyUrlExtension, friendlyUrlId, userType, userEntityId) => {
  const restrictIdDisplayingBases = getRestrictIdDisplayingBases(userType);
  const exactId = restrictIdDisplayingBases.includes(exactUrlBase) ? userEntityId : friendlyUrlId;
  return friendlyUrlExtension === FRIENDLY_URL_EXTENSIONS.virtualOffice ? [exactId, '1'].join('/') : exactId;
}

/**
 * Returns a list of URL bases for which displaying of id is restricted
 * @param {string|number} userType Logged in user type should be one of [0, 1, 2]
 * @returns {[]}
 */
const getRestrictIdDisplayingBases = (userType) => {
  let restrictIdDisplayingBases = [];
  switch (parseInt(userType)) {
    case USER_TYPES.reseller:
      restrictIdDisplayingBases = [FRIENDLY_URL_BASES.reseller, FRIENDLY_URL_BASES.reseller_settings];
      break;
    case USER_TYPES.client:
      restrictIdDisplayingBases = [FRIENDLY_URL_BASES.client, FRIENDLY_URL_BASES.client_settings, FRIENDLY_URL_BASES.inventory];
      break;
    default:
      break;
  }

  return restrictIdDisplayingBases
}

/**
 * Returns the tab class for opening the correct tab depending on exact URL address and user type
 * @param {string} exactUrl Constructed from friendly URL real URL address
 * @param {string|number} userType Logged in user type should be one of [0, 1, 2]
 * @returns {null|string}
 */
const getRelatedTab = (exactUrl, userType) => {
  let exactUrlBase;
  let exactUrlExtension;
  let exactUrlId;
  if (exactUrl) {
    const splitUrl = exactUrl.split('/');
    exactUrlBase = splitUrl[0];
    exactUrlExtension = splitUrl[1];
    exactUrlId = getUrlId(exactUrl);
  }
  let resellerTab;
  let applianceTab;
  let deviceTab;
  let dashboardTab;
  switch (parseInt(userType)) {
    case USER_TYPES.axcient:
      resellerTab = TAB_SELECTORS.resellers;
      applianceTab = TAB_SELECTORS.supportAppliances;
      deviceTab = TAB_SELECTORS.clients;
      break;
    case USER_TYPES.distributor:
      resellerTab = TAB_SELECTORS.resellers;
      break;
    case USER_TYPES.reseller:
      resellerTab = TAB_SELECTORS.resellerDashboard;
      applianceTab = TAB_SELECTORS.appliances;
      deviceTab = TAB_SELECTORS.clients;
      dashboardTab = TAB_SELECTORS.resellerDashboard;
      break;
    case USER_TYPES.client:
      applianceTab = TAB_SELECTORS.clients;
      deviceTab = TAB_SELECTORS.clients;
      dashboardTab = TAB_SELECTORS.clients;
      break;
    default:
      return null;
  }

  const tabClassMap = {
    'distributor': TAB_SELECTORS.distributor,
    'reseller': resellerTab,
    'client': TAB_SELECTORS.clients,
    'dashboardumc': TAB_SELECTORS.clients,
    'appliance': exactUrlId ? TAB_SELECTORS.clients : applianceTab,
    'dashboard': TAB_SELECTORS.appliances,
    'azure_export': dashboardTab,
    'device': deviceTab,
    'job': TAB_SELECTORS.clients,
    'devices': TAB_SELECTORS.devices,
    'vault': TAB_SELECTORS.vault,
    'user': TAB_SELECTORS.users,
    'licenses': TAB_SELECTORS.licenses,
    'reports': TAB_SELECTORS.reports,
    'admin': TAB_SELECTORS.admin,
    'upgrader': TAB_SELECTORS.support,
    'settings': {
      'client_settings': TAB_SELECTORS.clients,
      'vault_settings': TAB_SELECTORS.vault,
      'reseller_settings': resellerTab,
      'appliance_settings': applianceTab,
      'virtualoffice_settings': TAB_SELECTORS.clients,
    },
  };
  if (exactUrlBase || exactUrlExtension) {
    const firstLevelSelection = exactUrlExtension === 'client_appliance_list' ? tabClassMap['client'] : tabClassMap[exactUrlBase];
    if (firstLevelSelection) {
      return typeof firstLevelSelection === 'string' ? firstLevelSelection : firstLevelSelection[exactUrlExtension];
    }
  }
  return null;
}

export {tabsGoTo, getRelatedTab, getExactUrlFromFriendly, createUserFriendlyUrl, activeTabReload, tabReloadByElement, initPopstateListener};
